import { Component } from '@angular/core';
import { RouteDetailModalPresenter } from '../route-report-modal/route-detail-modal.presenter';

@Component({ selector: 'route-driver-salary-modal', templateUrl: './route-driver-salary-modal.component.html' })
export class RouteDriverSalaryModalComponent extends RouteDetailModalPresenter {
  readonly kind = 'salary' as const;
}
